import { gql } from '@apollo/client'

export const GET_AUDIENCES = gql`
    query GetAudiences {
        Audience {
            audiences {
                id
                name
                icon
                description
                funnel_stage
                lookalike
                ai
                active
                default
                created_at
                updated_at
            }
        }
    }
`

export const GET_AUDIENCES_WITH_FILTERS = gql`
    query GetAudiencesWithFilters(
        $funnel_stages: [FunnelStage!]
        $searchTerm: String
        $active: Boolean
        $campaignId: ID
    ) {
        Audience {
            audiences(
                funnel_stages: $funnel_stages
                searchTerm: $searchTerm
                active: $active
                campaignId: $campaignId
            ) {
                id
                name
                icon
                description
                funnel_stage
                lookalike
                ai
                active
                default
                created_at
                updated_at
                created_count
                live_count
            }
        }
    }
`

export const GET_AUDIENCES_BY_FUNNEL_STAGE = gql`
    query GetAudiencesByFunnelStage($funnelStage: FunnelStage!) {
        Audience {
            audiences {
                id
                name
                icon
                description
                funnel_stage
                lookalike
                ai
                active
                default
                created_at
                updated_at
            }
        }
    }
`

export const GET_ACTIVE_AUDIENCES = gql`
    query GetActiveAudiences {
        Audience {
            audiences {
                id
                name
                icon
                description
                funnel_stage
                lookalike
                ai
                active
                default
                created_at
                updated_at
            }
        }
    }
`
